import { render, staticRenderFns } from "./TasksListPanel.vue?vue&type=template&id=13340583&scoped=true&"
import script from "./TasksListPanel.vue?vue&type=script&lang=js&"
export * from "./TasksListPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13340583",
  null
  
)

export default component.exports